// M07 指數、指數函數與對數函數 - Topics 01 to 10
// 涵蓋：指數定律、方程轉換、對數計算、對數性質、二次方程、函數變換、圖像繪製、指數定律、分數指數、代數化簡

export const M07_TOPICS_01_TO_10 = [
  {
    id: 'M07_01',
    name: '指數定律',
    description: '掌握指數運算的基本定律和規則',
    difficulty: 'intermediate'
  },
  {
    id: 'M07_02', 
    name: '方程轉換',
    description: '學習指數和對數方程的相互轉換',
    difficulty: 'intermediate'
  },
  {
    id: 'M07_03',
    name: '對數計算', 
    description: '掌握對數的基本計算方法',
    difficulty: 'intermediate'
  },
  {
    id: 'M07_04',
    name: '對數性質',
    description: '理解和應用對數的各種性質',
    difficulty: 'intermediate'
  },
  {
    id: 'M07_05',
    name: '二次方程',
    description: '解決涉及指數和對數的二次方程',
    difficulty: 'advanced'
  },
  {
    id: 'M07_06',
    name: '函數變換',
    description: '理解指數和對數函數的變換',
    difficulty: 'advanced'
  },
  {
    id: 'M07_07',
    name: '圖像繪製',
    description: '繪製指數和對數函數的圖像',
    difficulty: 'intermediate'
  },
  {
    id: 'M07_08',
    name: '指數定律',
    description: '深入理解複雜的指數運算',
    difficulty: 'advanced'
  },
  {
    id: 'M07_09',
    name: '分數指數',
    description: '處理分數和負數指數的運算',
    difficulty: 'advanced'
  },
  {
    id: 'M07_10',
    name: '代數化簡',
    description: '化簡包含指數和對數的代數式',
    difficulty: 'intermediate'
  }
];

export const M07_PROBLEMS_01_TO_10 = [
  // Topic 1: 指數定律 (5 questions)
  {
    id: 'M07_01_01',
    topicId: 'M07_01',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '利用指數定律化簡下列表達式：',
    parts: {
      a: {
        question: '計算 $2^3 \\times 2^5$',
        solution: {
          steps: [
            '根據指數定律：$a^m \\times a^n = a^{m+n}$',
            '應用定律：$2^3 \\times 2^5 = 2^{3+5} = 2^8$',
            '計算結果：$2^8 = 256$'
          ],
          answer: '$2^8 = 256$'
        },
        hint: '當底數相同時，指數相乘等於指數相加'
      },
      b: {
        question: '計算 $\\frac{3^7}{3^4}$',
        solution: {
          steps: [
            '根據指數定律：$\\frac{a^m}{a^n} = a^{m-n}$',
            '應用定律：$\\frac{3^7}{3^4} = 3^{7-4} = 3^3$',
            '計算結果：$3^3 = 27$'
          ],
          answer: '$3^3 = 27$'
        },
        hint: '當底數相同時，指數相除等於指數相減'
      },
      c: {
        question: '計算 $(5^2)^3$',
        solution: {
          steps: [
            '根據指數定律：$(a^m)^n = a^{mn}$',
            '應用定律：$(5^2)^3 = 5^{2 \\times 3} = 5^6$',
            '計算結果：$5^6 = 15625$'
          ],
          answer: '$5^6 = 15625$'
        },
        hint: '指數的指數等於指數相乘'
      }
    }
  },
  {
    id: 'M07_01_02',
    topicId: 'M07_01',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '應用指數定律求解：',
    parts: {
      a: {
        question: '化簡 $4^x \\times 4^{2x}$',
        solution: {
          steps: [
            '根據指數定律：$a^m \\times a^n = a^{m+n}$',
            '應用定律：$4^x \\times 4^{2x} = 4^{x+2x} = 4^{3x}$',
            '最終答案：$4^{3x}$'
          ],
          answer: '$4^{3x}$'
        },
        hint: '含變數的指數運算同樣適用指數定律'
      },
      b: {
        question: '化簡 $\\frac{7^{3x}}{7^x}$',
        solution: {
          steps: [
            '根據指數定律：$\\frac{a^m}{a^n} = a^{m-n}$',
            '應用定律：$\\frac{7^{3x}}{7^x} = 7^{3x-x} = 7^{2x}$',
            '最終答案：$7^{2x}$'
          ],
          answer: '$7^{2x}$'
        },
        hint: '指數相除時，指數相減'
      },
      c: {
        question: '化簡 $(2^x)^4$',
        solution: {
          steps: [
            '根據指數定律：$(a^m)^n = a^{mn}$',
            '應用定律：$(2^x)^4 = 2^{x \\times 4} = 2^{4x}$',
            '最終答案：$2^{4x}$'
          ],
          answer: '$2^{4x}$'
        },
        hint: '指數的指數等於指數相乘'
      }
    }
  },
  {
    id: 'M07_01_03',
    topicId: 'M07_01',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '利用指數定律解決複合運算：',
    parts: {
      a: {
        question: '計算 $2^3 \\times 2^2 \\times 2^4$',
        solution: {
          steps: [
            '根據指數定律：$a^m \\times a^n \\times a^p = a^{m+n+p}$',
            '應用定律：$2^3 \\times 2^2 \\times 2^4 = 2^{3+2+4} = 2^9$',
            '計算結果：$2^9 = 512$'
          ],
          answer: '$2^9 = 512$'
        },
        hint: '多個同底數相乘時，指數全部相加'
      },
      b: {
        question: '化簡 $\\frac{6^8}{6^3 \\times 6^2}$',
        solution: {
          steps: [
            '先化簡分母：$6^3 \\times 6^2 = 6^{3+2} = 6^5$',
            '應用除法定律：$\\frac{6^8}{6^5} = 6^{8-5} = 6^3$',
            '計算結果：$6^3 = 216$'
          ],
          answer: '$6^3 = 216$'
        },
        hint: '先化簡分母，再應用除法定律'
      },
      c: {
        question: '計算 $\\frac{(3^2)^4}{3^5}$',
        solution: {
          steps: [
            '先化簡分子：$(3^2)^4 = 3^{2 \\times 4} = 3^8$',
            '應用除法定律：$\\frac{3^8}{3^5} = 3^{8-5} = 3^3$',
            '計算結果：$3^3 = 27$'
          ],
          answer: '$3^3 = 27$'
        },
        hint: '先處理指數的指數，再進行除法運算'
      }
    }
  },
  {
    id: 'M07_01_04',
    topicId: 'M07_01',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '解決包含負指數的運算：',
    parts: {
      a: {
        question: '計算 $5^{-2} \\times 5^5$',
        solution: {
          steps: [
            '根據指數定律：$a^m \\times a^n = a^{m+n}$',
            '應用定律：$5^{-2} \\times 5^5 = 5^{-2+5} = 5^3$',
            '計算結果：$5^3 = 125$'
          ],
          answer: '$5^3 = 125$'
        },
        hint: '負指數也遵循相同的指數定律'
      },
      b: {
        question: '化簡 $\\frac{4^3}{4^{-2}}$',
        solution: {
          steps: [
            '根據指數定律：$\\frac{a^m}{a^n} = a^{m-n}$',
            '應用定律：$\\frac{4^3}{4^{-2}} = 4^{3-(-2)} = 4^{3+2} = 4^5$',
            '計算結果：$4^5 = 1024$'
          ],
          answer: '$4^5 = 1024$'
        },
        hint: '減去負數等於加上正數'
      },
      c: {
        question: '計算 $(2^{-3})^{-2}$',
        solution: {
          steps: [
            '根據指數定律：$(a^m)^n = a^{mn}$',
            '應用定律：$(2^{-3})^{-2} = 2^{(-3) \\times (-2)} = 2^6$',
            '計算結果：$2^6 = 64$'
          ],
          answer: '$2^6 = 64$'
        },
        hint: '負數乘以負數得正數'
      }
    }
  },
  {
    id: 'M07_01_05',
    topicId: 'M07_01',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '解決混合指數運算：',
    parts: {
      a: {
        question: '化簡 $\\frac{8^x \\times 8^{2x}}{8^{x}}$',
        solution: {
          steps: [
            '先化簡分子：$8^x \\times 8^{2x} = 8^{x+2x} = 8^{3x}$',
            '應用除法定律：$\\frac{8^{3x}}{8^x} = 8^{3x-x} = 8^{2x}$',
            '最終答案：$8^{2x}$'
          ],
          answer: '$8^{2x}$'
        },
        hint: '先處理分子的乘法，再進行除法'
      },
      b: {
        question: '計算 $\\frac{(3^2)^x \\times 3^{3x}}{(3^x)^2}$',
        solution: {
          steps: [
            '化簡各部分：$(3^2)^x = 3^{2x}$，$(3^x)^2 = 3^{2x}$',
            '分子變為：$3^{2x} \\times 3^{3x} = 3^{2x+3x} = 3^{5x}$',
            '最終計算：$\\frac{3^{5x}}{3^{2x}} = 3^{5x-2x} = 3^{3x}$'
          ],
          answer: '$3^{3x}$'
        },
        hint: '逐步化簡各個指數表達式'
      },
      c: {
        question: '求解 $2^{2x-1} = 2^{x+3}$',
        solution: {
          steps: [
            '由於底數相同，指數必須相等：$2x-1 = x+3$',
            '移項求解：$2x - x = 3 + 1$，得 $x = 4$',
            '驗證：$2^{2(4)-1} = 2^7$，$2^{4+3} = 2^7$ ✓'
          ],
          answer: '$x = 4$'
        },
        hint: '當底數相同時，指數必須相等'
      }
    }
  },

  // Topic 2: 方程轉換 (5 questions)
  {
    id: 'M07_02_01',
    topicId: 'M07_02',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '將指數方程轉換為對數方程：',
    parts: {
      a: {
        question: '將 $2^3 = 8$ 轉換為對數形式',
        solution: {
          steps: [
            '指數方程 $a^x = b$ 對應對數方程 $\\log_a b = x$',
            '套用公式：$2^3 = 8$ 對應 $\\log_2 8 = 3$',
            '驗證：$\\log_2 8 = 3$ 表示 2 的 3 次方等於 8'
          ],
          answer: '$\\log_2 8 = 3$'
        },
        hint: '指數方程 $a^x = b$ 等價於對數方程 $\\log_a b = x$'
      },
      b: {
        question: '將 $5^x = 125$ 轉換為對數形式',
        solution: {
          steps: [
            '應用轉換公式：$a^x = b \\Leftrightarrow \\log_a b = x$',
            '轉換：$5^x = 125$ 變為 $\\log_5 125 = x$',
            '計算：$\\log_5 125 = \\log_5 5^3 = 3$，所以 $x = 3$'
          ],
          answer: '$\\log_5 125 = x$，其中 $x = 3$'
        },
        hint: '先轉換形式，再計算對數值'
      },
      c: {
        question: '將 $10^{-2} = 0.01$ 轉換為對數形式',
        solution: {
          steps: [
            '應用轉換公式：$a^x = b \\Leftrightarrow \\log_a b = x$',
            '轉換：$10^{-2} = 0.01$ 變為 $\\log_{10} 0.01 = -2$',
            '這就是常用對數：$\\lg 0.01 = -2$'
          ],
          answer: '$\\log_{10} 0.01 = -2$ 或 $\\lg 0.01 = -2$'
        },
        hint: '負指數對應負對數'
      }
    }
  },
  {
    id: 'M07_02_02',
    topicId: 'M07_02',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '將對數方程轉換為指數方程：',
    parts: {
      a: {
        question: '將 $\\log_3 27 = 3$ 轉換為指數形式',
        solution: {
          steps: [
            '對數方程 $\\log_a b = x$ 對應指數方程 $a^x = b$',
            '套用公式：$\\log_3 27 = 3$ 對應 $3^3 = 27$',
            '驗證：$3^3 = 27$ ✓'
          ],
          answer: '$3^3 = 27$'
        },
        hint: '對數方程 $\\log_a b = x$ 等價於指數方程 $a^x = b$'
      },
      b: {
        question: '將 $\\log_2 x = 5$ 轉換為指數形式',
        solution: {
          steps: [
            '應用轉換公式：$\\log_a b = x \\Leftrightarrow a^x = b$',
            '轉換：$\\log_2 x = 5$ 變為 $2^5 = x$',
            '計算：$2^5 = 32$，所以 $x = 32$'
          ],
          answer: '$2^5 = x$，其中 $x = 32$'
        },
        hint: '轉換後可以直接計算未知數的值'
      },
      c: {
        question: '將 $\\ln e^4 = 4$ 轉換為指數形式',
        solution: {
          steps: [
            '自然對數 $\\ln$ 的底數是 $e$',
            '轉換：$\\ln e^4 = 4$ 等價於 $\\log_e e^4 = 4$',
            '對應指數形式：$e^4 = e^4$（這是恆等式）'
          ],
          answer: '$e^4 = e^4$'
        },
        hint: '自然對數的底數是 e'
      }
    }
  },
  {
    id: 'M07_02_03',
    topicId: 'M07_02',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '解決方程轉換應用題：',
    parts: {
      a: {
        question: '如果 $3^x = 81$，求 $x$ 的值',
        solution: {
          steps: [
            '將指數方程轉換為對數方程：$\\log_3 81 = x$',
            '計算：$81 = 3^4$，所以 $\\log_3 3^4 = 4$',
            '因此 $x = 4$'
          ],
          answer: '$x = 4$'
        },
        hint: '先轉換為對數形式，再計算'
      },
      b: {
        question: '如果 $\\log_5 x = 2$，求 $x$ 的值',
        solution: {
          steps: [
            '將對數方程轉換為指數方程：$5^2 = x$',
            '計算：$5^2 = 25$',
            '因此 $x = 25$'
          ],
          answer: '$x = 25$'
        },
        hint: '轉換為指數形式後直接計算'
      },
      c: {
        question: '如果 $2^{x+1} = 16$，求 $x$ 的值',
        solution: {
          steps: [
            '轉換為對數形式：$\\log_2 16 = x + 1$',
            '計算：$16 = 2^4$，所以 $\\log_2 2^4 = 4$',
            '求解：$x + 1 = 4$，得 $x = 3$'
          ],
          answer: '$x = 3$'
        },
        hint: '注意指數是 x+1，不是 x'
      }
    }
  },
  {
    id: 'M07_02_04',
    topicId: 'M07_02',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '處理複雜的方程轉換：',
    parts: {
      a: {
        question: '將 $4^x = 2^{x+3}$ 轉換為同底數形式',
        solution: {
          steps: [
            '將 4 表示為 2 的指數：$4 = 2^2$',
            '代入：$(2^2)^x = 2^{x+3}$，即 $2^{2x} = 2^{x+3}$',
            '由於底數相同：$2x = x + 3$，解得 $x = 3$'
          ],
          answer: '$x = 3$'
        },
        hint: '將所有項轉換為相同底數'
      },
      b: {
        question: '解方程 $\\log_2(x+1) + \\log_2(x-1) = 3$',
        solution: {
          steps: [
            '利用對數性質：$\\log_2(x+1) + \\log_2(x-1) = \\log_2[(x+1)(x-1)]$',
            '化簡：$\\log_2(x^2-1) = 3$',
            '轉換為指數形式：$2^3 = x^2 - 1$，即 $8 = x^2 - 1$，$x^2 = 9$，$x = ±3$'
          ],
          answer: '$x = 3$（$x = -3$ 不符合定義域）'
        },
        hint: '注意對數的定義域限制'
      },
      c: {
        question: '解方程 $3^{2x} - 3^{x+1} + 3 = 0$',
        solution: {
          steps: [
            '設 $y = 3^x$，則 $3^{2x} = (3^x)^2 = y^2$，$3^{x+1} = 3 \\cdot 3^x = 3y$',
            '代入方程：$y^2 - 3y + 3 = 0$',
            '使用二次公式：$y = \\frac{3 ± \\sqrt{9-12}}{2} = \\frac{3 ± \\sqrt{-3}}{2}$（無實數解）'
          ],
          answer: '無實數解'
        },
        hint: '使用代換法將指數方程轉換為二次方程'
      }
    }
  },
  {
    id: 'M07_02_05',
    topicId: 'M07_02',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '綜合方程轉換技巧：',
    parts: {
      a: {
        question: '解方程 $\\log_x 8 = 3$',
        solution: {
          steps: [
            '轉換為指數形式：$x^3 = 8$',
            '計算：$x^3 = 2^3$',
            '因此 $x = 2$'
          ],
          answer: '$x = 2$'
        },
        hint: '未知數在底數位置時，轉換為指數形式'
      },
      b: {
        question: '解方程 $2^{x^2} = 2^{6x-8}$',
        solution: {
          steps: [
            '由於底數相同，指數必須相等：$x^2 = 6x - 8$',
            '重新排列：$x^2 - 6x + 8 = 0$',
            '因式分解：$(x-2)(x-4) = 0$，得 $x = 2$ 或 $x = 4$'
          ],
          answer: '$x = 2$ 或 $x = 4$'
        },
        hint: '底數相同時，指數必須相等'
      },
      c: {
        question: '解方程 $\\log_2(x-1) = \\log_2(2x-5)$',
        solution: {
          steps: [
            '由於底數相同，真數必須相等：$x - 1 = 2x - 5$',
            '解方程：$-1 + 5 = 2x - x$，得 $4 = x$',
            '檢驗定義域：$x > 1$ 且 $2x > 5$，即 $x > 2.5$，$x = 4$ 符合條件'
          ],
          answer: '$x = 4$'
        },
        hint: '檢查對數的定義域是否滿足'
      }
    }
  },

  // Topic 3: 對數計算 (5 questions)
  {
    id: 'M07_03_01',
    topicId: 'M07_03',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '計算基本對數值：',
    parts: {
      a: {
        question: '計算 $\\log_2 32$',
        solution: {
          steps: [
            '將 32 表示為 2 的指數：$32 = 2^5$',
            '應用對數定義：$\\log_2 32 = \\log_2 2^5 = 5$',
            '驗證：$2^5 = 32$ ✓'
          ],
          answer: '$\\log_2 32 = 5$'
        },
        hint: '將真數表示為底數的指數形式'
      },
      b: {
        question: '計算 $\\log_3 \\frac{1}{27}$',
        solution: {
          steps: [
            '將 $\\frac{1}{27}$ 表示為 3 的指數：$\\frac{1}{27} = \\frac{1}{3^3} = 3^{-3}$',
            '應用對數定義：$\\log_3 \\frac{1}{27} = \\log_3 3^{-3} = -3$',
            '驗證：$3^{-3} = \\frac{1}{27}$ ✓'
          ],
          answer: '$\\log_3 \\frac{1}{27} = -3$'
        },
        hint: '負指數對應負對數'
      },
      c: {
        question: '計算 $\\log_5 \\sqrt{125}$',
        solution: {
          steps: [
            '將 $\\sqrt{125}$ 表示為指數形式：$\\sqrt{125} = 125^{\\frac{1}{2}} = (5^3)^{\\frac{1}{2}} = 5^{\\frac{3}{2}}$',
            '應用對數定義：$\\log_5 \\sqrt{125} = \\log_5 5^{\\frac{3}{2}} = \\frac{3}{2}$',
            '驗證：$5^{\\frac{3}{2}} = \\sqrt{5^3} = \\sqrt{125}$ ✓'
          ],
          answer: '$\\log_5 \\sqrt{125} = \\frac{3}{2}$'
        },
        hint: '根號可以表示為分數指數'
      }
    }
  },
  {
    id: 'M07_03_02',
    topicId: 'M07_03',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '計算常用對數和自然對數：',
    parts: {
      a: {
        question: '計算 $\\lg 1000$（常用對數）',
        solution: {
          steps: [
            '常用對數的底數是 10：$\\lg 1000 = \\log_{10} 1000$',
            '將 1000 表示為 10 的指數：$1000 = 10^3$',
            '計算：$\\log_{10} 10^3 = 3$'
          ],
          answer: '$\\lg 1000 = 3$'
        },
        hint: '常用對數 lg 的底數是 10'
      },
      b: {
        question: '計算 $\\ln e^2$（自然對數）',
        solution: {
          steps: [
            '自然對數的底數是 e：$\\ln e^2 = \\log_e e^2$',
            '應用對數定義：$\\log_e e^2 = 2$',
            '驗證：$e^2 = e^2$ ✓'
          ],
          answer: '$\\ln e^2 = 2$'
        },
        hint: '自然對數 ln 的底數是 e'
      },
      c: {
        question: '計算 $\\lg 0.001$',
        solution: {
          steps: [
            '將 0.001 表示為 10 的指數：$0.001 = \\frac{1}{1000} = \\frac{1}{10^3} = 10^{-3}$',
            '計算：$\\lg 0.001 = \\log_{10} 10^{-3} = -3$',
            '驗證：$10^{-3} = 0.001$ ✓'
          ],
          answer: '$\\lg 0.001 = -3$'
        },
        hint: '小於 1 的數對應負對數'
      }
    }
  },
  {
    id: 'M07_03_03',
    topicId: 'M07_03',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '利用對數性質計算：',
    parts: {
      a: {
        question: '計算 $\\log_2 8 + \\log_2 4$',
        solution: {
          steps: [
            '分別計算：$\\log_2 8 = \\log_2 2^3 = 3$，$\\log_2 4 = \\log_2 2^2 = 2$',
            '相加：$\\log_2 8 + \\log_2 4 = 3 + 2 = 5$',
            '或使用對數性質：$\\log_2 8 + \\log_2 4 = \\log_2(8 \\times 4) = \\log_2 32 = 5$'
          ],
          answer: '$\\log_2 8 + \\log_2 4 = 5$'
        },
        hint: '可以分別計算或使用對數加法性質'
      },
      b: {
        question: '計算 $\\log_3 27 - \\log_3 9$',
        solution: {
          steps: [
            '分別計算：$\\log_3 27 = \\log_3 3^3 = 3$，$\\log_3 9 = \\log_3 3^2 = 2$',
            '相減：$\\log_3 27 - \\log_3 9 = 3 - 2 = 1$',
            '或使用對數性質：$\\log_3 27 - \\log_3 9 = \\log_3 \\frac{27}{9} = \\log_3 3 = 1$'
          ],
          answer: '$\\log_3 27 - \\log_3 9 = 1$'
        },
        hint: '可以分別計算或使用對數減法性質'
      },
      c: {
        question: '計算 $2\\log_5 5$',
        solution: {
          steps: [
            '計算 $\\log_5 5$：由對數定義，$\\log_5 5 = 1$',
            '乘以 2：$2\\log_5 5 = 2 \\times 1 = 2$',
            '或使用對數性質：$2\\log_5 5 = \\log_5 5^2 = \\log_5 25 = 2$'
          ],
          answer: '$2\\log_5 5 = 2$'
        },
        hint: '任何數以自己為底的對數等於 1'
      }
    }
  },
  {
    id: 'M07_03_04',
    topicId: 'M07_03',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '計算複雜對數表達式：',
    parts: {
      a: {
        question: '計算 $\\log_2 \\sqrt[3]{8}$',
        solution: {
          steps: [
            '將立方根表示為分數指數：$\\sqrt[3]{8} = 8^{\\frac{1}{3}}$',
            '將 8 表示為 2 的指數：$8^{\\frac{1}{3}} = (2^3)^{\\frac{1}{3}} = 2^{3 \\times \\frac{1}{3}} = 2^1 = 2$',
            '計算：$\\log_2 \\sqrt[3]{8} = \\log_2 2 = 1$'
          ],
          answer: '$\\log_2 \\sqrt[3]{8} = 1$'
        },
        hint: '將根號轉換為分數指數'
      },
      b: {
        question: '計算 $\\log_4 \\frac{1}{\\sqrt{2}}$',
        solution: {
          steps: [
            '將表達式轉換：$\\frac{1}{\\sqrt{2}} = 2^{-\\frac{1}{2}}$',
            '將底數 4 表示為 2 的指數：$4 = 2^2$',
            '使用換底公式：$\\log_4 2^{-\\frac{1}{2}} = \\frac{\\log_2 2^{-\\frac{1}{2}}}{\\log_2 4} = \\frac{-\\frac{1}{2}}{2} = -\\frac{1}{4}$'
          ],
          answer: '$\\log_4 \\frac{1}{\\sqrt{2}} = -\\frac{1}{4}$'
        },
        hint: '使用換底公式或將所有項轉換為相同底數'
      },
      c: {
        question: '計算 $\\log_9 3 + \\log_{27} 9$',
        solution: {
          steps: [
            '計算第一項：$\\log_9 3 = \\log_{3^2} 3 = \\frac{1}{2}$',
            '計算第二項：$\\log_{27} 9 = \\log_{3^3} 3^2 = \\frac{2}{3}$',
            '相加：$\\frac{1}{2} + \\frac{2}{3} = \\frac{3}{6} + \\frac{4}{6} = \\frac{7}{6}$'
          ],
          answer: '$\\log_9 3 + \\log_{27} 9 = \\frac{7}{6}$'
        },
        hint: '將所有項轉換為以 3 為底數的形式'
      }
    }
  },
  {
    id: 'M07_03_05',
    topicId: 'M07_03',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '應用換底公式計算：',
    parts: {
      a: {
        question: '用換底公式計算 $\\log_2 10$（保留小數）',
        solution: {
          steps: [
            '應用換底公式：$\\log_2 10 = \\frac{\\log 10}{\\log 2} = \\frac{\\lg 10}{\\lg 2}$',
            '計算：$\\lg 10 = 1$，$\\lg 2 ≈ 0.3010$',
            '結果：$\\log_2 10 = \\frac{1}{0.3010} ≈ 3.322$'
          ],
          answer: '$\\log_2 10 ≈ 3.322$'
        },
        hint: '換底公式：$\\log_a b = \\frac{\\log_c b}{\\log_c a}$'
      },
      b: {
        question: '計算 $\\log_8 4$',
        solution: {
          steps: [
            '將底數和真數都表示為 2 的指數：$8 = 2^3$，$4 = 2^2$',
            '應用換底公式：$\\log_8 4 = \\frac{\\log_2 4}{\\log_2 8} = \\frac{2}{3}$',
            '驗證：$8^{\\frac{2}{3}} = (2^3)^{\\frac{2}{3}} = 2^2 = 4$ ✓'
          ],
          answer: '$\\log_8 4 = \\frac{2}{3}$'
        },
        hint: '將底數和真數轉換為相同的基本底數'
      },
      c: {
        question: '計算 $\\log_5 2 \\times \\log_2 5$',
        solution: {
          steps: [
            '設 $\\log_5 2 = x$，則 $5^x = 2$',
            '對兩邊取以 2 為底的對數：$\\log_2 5^x = \\log_2 2 = 1$',
            '得到：$x \\log_2 5 = 1$，即 $\\log_5 2 \\times \\log_2 5 = 1$'
          ],
          answer: '$\\log_5 2 \\times \\log_2 5 = 1$'
        },
        hint: '這是換底公式的特殊情況：$\\log_a b \\times \\log_b a = 1$'
      }
    }
  },

  // Topic 4: 對數性質 (5 questions)
  {
    id: 'M07_04_01',
    topicId: 'M07_04',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '應用對數加法性質：',
    parts: {
      a: {
        question: '化簡 $\\log_3 6 + \\log_3 2$',
        solution: {
          steps: [
            '應用對數加法性質：$\\log_a x + \\log_a y = \\log_a(xy)$',
            '計算：$\\log_3 6 + \\log_3 2 = \\log_3(6 \\times 2) = \\log_3 12$',
            '進一步化簡：$12 = 3 \\times 4$，但無法再簡化為 3 的整數次方'
          ],
          answer: '$\\log_3 12$'
        },
        hint: '對數加法：$\\log_a x + \\log_a y = \\log_a(xy)$'
      },
      b: {
        question: '計算 $\\log_2 3 + \\log_2 \\frac{8}{3}$',
        solution: {
          steps: [
            '應用對數加法性質：$\\log_2 3 + \\log_2 \\frac{8}{3} = \\log_2(3 \\times \\frac{8}{3})$',
            '化簡真數：$3 \\times \\frac{8}{3} = 8$',
            '計算：$\\log_2 8 = \\log_2 2^3 = 3$'
          ],
          answer: '$\\log_2 3 + \\log_2 \\frac{8}{3} = 3$'
        },
        hint: '先應用加法性質，再化簡真數'
      },
      c: {
        question: '化簡 $\\lg 2 + \\lg 5$',
        solution: {
          steps: [
            '應用對數加法性質：$\\lg 2 + \\lg 5 = \\lg(2 \\times 5) = \\lg 10$',
            '計算：$\\lg 10 = \\log_{10} 10 = 1$',
            '驗證：$10^1 = 10$ ✓'
          ],
          answer: '$\\lg 2 + \\lg 5 = 1$'
        },
        hint: '常用對數中，$\\lg 10 = 1$'
      }
    }
  },
  {
    id: 'M07_04_02',
    topicId: 'M07_04',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '應用對數減法性質：',
    parts: {
      a: {
        question: '化簡 $\\log_5 20 - \\log_5 4$',
        solution: {
          steps: [
            '應用對數減法性質：$\\log_a x - \\log_a y = \\log_a \\frac{x}{y}$',
            '計算：$\\log_5 20 - \\log_5 4 = \\log_5 \\frac{20}{4} = \\log_5 5$',
            '結果：$\\log_5 5 = 1$'
          ],
          answer: '$\\log_5 20 - \\log_5 4 = 1$'
        },
        hint: '對數減法：$\\log_a x - \\log_a y = \\log_a \\frac{x}{y}$'
      },
      b: {
        question: '計算 $\\ln 6 - \\ln 2$',
        solution: {
          steps: [
            '應用對數減法性質：$\\ln 6 - \\ln 2 = \\ln \\frac{6}{2} = \\ln 3$',
            '結果保持為 $\\ln 3$（無法進一步化簡）',
            '驗證：$e^{\\ln 3} = 3$ ✓'
          ],
          answer: '$\\ln 6 - \\ln 2 = \\ln 3$'
        },
        hint: '自然對數也遵循相同的減法性質'
      },
      c: {
        question: '化簡 $\\log_7 49 - \\log_7 7$',
        solution: {
          steps: [
            '應用對數減法性質：$\\log_7 49 - \\log_7 7 = \\log_7 \\frac{49}{7} = \\log_7 7$',
            '計算：$\\log_7 7 = 1$',
            '或分別計算：$\\log_7 49 = \\log_7 7^2 = 2$，$\\log_7 7 = 1$，$2 - 1 = 1$'
          ],
          answer: '$\\log_7 49 - \\log_7 7 = 1$'
        },
        hint: '可以使用減法性質或分別計算'
      }
    }
  },
  {
    id: 'M07_04_03',
    topicId: 'M07_04',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '應用對數乘法性質：',
    parts: {
      a: {
        question: '化簡 $3\\log_2 4$',
        solution: {
          steps: [
            '應用對數乘法性質：$n\\log_a x = \\log_a x^n$',
            '計算：$3\\log_2 4 = \\log_2 4^3 = \\log_2 64$',
            '進一步計算：$\\log_2 64 = \\log_2 2^6 = 6$'
          ],
          answer: '$3\\log_2 4 = 6$'
        },
        hint: '對數乘法：$n\\log_a x = \\log_a x^n$'
      },
      b: {
        question: '計算 $\\frac{1}{2}\\log_3 9$',
        solution: {
          steps: [
            '應用對數乘法性質：$\\frac{1}{2}\\log_3 9 = \\log_3 9^{\\frac{1}{2}} = \\log_3 \\sqrt{9}$',
            '化簡：$\\sqrt{9} = 3$',
            '計算：$\\log_3 3 = 1$'
          ],
          answer: '$\\frac{1}{2}\\log_3 9 = 1$'
        },
        hint: '分數係數對應根號運算'
      },
      c: {
        question: '化簡 $-2\\log_5 \\frac{1}{5}$',
        solution: {
          steps: [
            '應用對數乘法性質：$-2\\log_5 \\frac{1}{5} = \\log_5 (\\frac{1}{5})^{-2}$',
            '化簡指數：$(\\frac{1}{5})^{-2} = (5^{-1})^{-2} = 5^2 = 25$',
            '計算：$\\log_5 25 = \\log_5 5^2 = 2$'
          ],
          answer: '$-2\\log_5 \\frac{1}{5} = 2$'
        },
        hint: '負係數會改變指數的符號'
      }
    }
  },
  {
    id: 'M07_04_04',
    topicId: 'M07_04',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '綜合應用對數性質：',
    parts: {
      a: {
        question: '化簡 $\\log_2 8 + \\log_2 4 - \\log_2 16$',
        solution: {
          steps: [
            '分別計算：$\\log_2 8 = 3$，$\\log_2 4 = 2$，$\\log_2 16 = 4$',
            '計算：$3 + 2 - 4 = 1$',
            '或使用性質：$\\log_2 8 + \\log_2 4 - \\log_2 16 = \\log_2 \\frac{8 \\times 4}{16} = \\log_2 2 = 1$'
          ],
          answer: '$\\log_2 8 + \\log_2 4 - \\log_2 16 = 1$'
        },
        hint: '可以分別計算或綜合使用對數性質'
      },
      b: {
        question: '化簡 $2\\log_3 6 - \\log_3 4$',
        solution: {
          steps: [
            '應用乘法性質：$2\\log_3 6 = \\log_3 6^2 = \\log_3 36$',
            '應用減法性質：$\\log_3 36 - \\log_3 4 = \\log_3 \\frac{36}{4} = \\log_3 9$',
            '計算：$\\log_3 9 = \\log_3 3^2 = 2$'
          ],
          answer: '$2\\log_3 6 - \\log_3 4 = 2$'
        },
        hint: '先處理係數，再應用減法性質'
      },
      c: {
        question: '化簡 $\\frac{1}{3}(\\log_5 125 + \\log_5 25)$',
        solution: {
          steps: [
            '先處理括號內：$\\log_5 125 + \\log_5 25 = \\log_5(125 \\times 25) = \\log_5 3125$',
            '計算：$3125 = 5^5$，所以 $\\log_5 3125 = 5$',
            '最終計算：$\\frac{1}{3} \\times 5 = \\frac{5}{3}$'
          ],
          answer: '$\\frac{1}{3}(\\log_5 125 + \\log_5 25) = \\frac{5}{3}$'
        },
        hint: '先處理括號內的運算，再處理係數'
      }
    }
  },
  {
    id: 'M07_04_05',
    topicId: 'M07_04',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複雜對數性質應用：',
    parts: {
      a: {
        question: '證明 $\\log_a x + \\log_a y = \\log_a(xy)$',
        solution: {
          steps: [
            '設 $\\log_a x = m$，$\\log_a y = n$',
            '則 $a^m = x$，$a^n = y$',
            '所以 $xy = a^m \\times a^n = a^{m+n}$，即 $\\log_a(xy) = m + n = \\log_a x + \\log_a y$'
          ],
          answer: '證明完成'
        },
        hint: '使用對數的定義進行證明'
      },
      b: {
        question: '化簡 $\\log_a \\sqrt[n]{x^m}$',
        solution: {
          steps: [
            '將根號表示為分數指數：$\\sqrt[n]{x^m} = x^{\\frac{m}{n}}$',
            '應用對數乘法性質：$\\log_a x^{\\frac{m}{n}} = \\frac{m}{n} \\log_a x$',
            '最終結果：$\\frac{m}{n} \\log_a x$'
          ],
          answer: '$\\log_a \\sqrt[n]{x^m} = \\frac{m}{n} \\log_a x$'
        },
        hint: '將根號轉換為分數指數'
      },
      c: {
        question: '解方程 $\\log_2(x+1) + \\log_2(x-1) = \\log_2 15$',
        solution: {
          steps: [
            '應用加法性質：$\\log_2[(x+1)(x-1)] = \\log_2 15$',
            '化簡：$\\log_2(x^2-1) = \\log_2 15$',
            '由於底數相同：$x^2 - 1 = 15$，$x^2 = 16$，$x = ±4$'
          ],
          answer: '$x = 4$（$x = -4$ 不符合定義域）'
        },
        hint: '注意檢查對數的定義域'
      }
    }
  },

  // Topics 5-10 continue with similar detailed structure...
  // Topic 5: 二次方程 (5 questions)
  {
    id: 'M07_05_01',
    topicId: 'M07_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '解含指數的二次方程：',
    parts: {
      a: {
        question: '解方程 $4^x - 5 \\cdot 2^x + 4 = 0$',
        solution: {
          steps: [
            '設 $y = 2^x$，則 $4^x = (2^2)^x = (2^x)^2 = y^2$',
            '代入方程：$y^2 - 5y + 4 = 0$',
            '因式分解：$(y-1)(y-4) = 0$，得 $y = 1$ 或 $y = 4$'
          ],
          answer: '$2^x = 1$ 或 $2^x = 4$，即 $x = 0$ 或 $x = 2$'
        },
        hint: '使用代換法將指數方程轉換為二次方程'
      },
      b: {
        question: '解方程 $9^x - 4 \\cdot 3^x + 3 = 0$',
        solution: {
          steps: [
            '設 $y = 3^x$，則 $9^x = (3^2)^x = (3^x)^2 = y^2$',
            '代入方程：$y^2 - 4y + 3 = 0$',
            '因式分解：$(y-1)(y-3) = 0$，得 $y = 1$ 或 $y = 3$'
          ],
          answer: '$3^x = 1$ 或 $3^x = 3$，即 $x = 0$ 或 $x = 1$'
        },
        hint: '將 $9^x$ 表示為 $(3^x)^2$'
      },
      c: {
        question: '解方程 $2^{2x} - 3 \\cdot 2^x + 2 = 0$',
        solution: {
          steps: [
            '設 $y = 2^x$，則 $2^{2x} = (2^x)^2 = y^2$',
            '代入方程：$y^2 - 3y + 2 = 0$',
            '因式分解：$(y-1)(y-2) = 0$，得 $y = 1$ 或 $y = 2$'
          ],
          answer: '$2^x = 1$ 或 $2^x = 2$，即 $x = 0$ 或 $x = 1$'
        },
        hint: '$2^{2x} = (2^x)^2$'
      }
    }
  }

  // Continue with remaining topics 6-10...
  // Due to length constraints, I'll continue with the remaining topics in the next part
];

export default M07_TOPICS_01_TO_10; 